module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="base-league-data" >\n	<div class="table-item type head_to_head">\n		<p>H2H</p>\n	</div>\n	<div class="table-item avatar">\n		<picture>\n			<source srcset="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" class="js-display-img" type="image/png">\n			<img src="/assets/images/test-avatar.png?v=1" alt="League avatar">\n		</picture>\n	</div>\n	<div class="table-item name">\n		<div class="league-name">\n            ';
 if(num_teams == size && opponent ) { 
__p+='\n			    <a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/fixtures">'+
((__t=( name ))==null?'':_.escape(__t))+
'</a>\n            ';
 }else { 
__p+='\n                <a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/ladder">'+
((__t=( name ))==null?'':_.escape(__t))+
'</a>\n            ';
 } 
__p+='\n		</div>\n		';
 if(status === "scheduled") { 
__p+='\n			<p>\n				';
 if( is_commissioner ) { 
__p+='\n					<a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/manage">Manage</a>\n				';
 } 
__p+='\n\n				';
 if( if_settings_access && is_commissioner ) { 
__p+='\n					<span>|</span>\n				';
 } 
__p+='\n\n				';
 if( if_settings_access ) { 
__p+='\n					<a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/manage/invites">Invites</a>\n				';
 } 
__p+='\n			</p>\n		';
 } 
__p+='\n\n		';
 if(winner) { 
__p+='\n			<p class="winner">Winner: '+
((__t=( winner.firstname ))==null?'':_.escape(__t))+
' '+
((__t=( winner.lastname ))==null?'':_.escape(__t))+
'</p>\n		';
 } 
__p+='\n	</div>\n	<div class="table-item size">\n		';
 if(status === "scheduled") { 
__p+='\n			'+
((__t=( num_teams ))==null?'':_.escape(__t))+
'/'+
((__t=( size ))==null?'':_.escape(__t))+
'\n			<p class="start-round">Starts R'+
((__t=( start_round ))==null?'':_.escape(__t))+
'</p>\n		';
 }else { 
__p+='\n			'+
((__t=( _.ordinalSuffixOf( rank ) ))==null?'':_.escape(__t))+
'\n\n			';
 if(winner) { 
__p+='\n				<p class="item-complete">Complete</p>\n			';
 } 
__p+='\n		';
 } 
__p+='\n	</div>\n	<div class="table-item arrow">\n        ';
 if(num_teams == size && opponent ) { 
__p+='\n            <a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/fixtures"></a>\n        ';
 }else { 
__p+='\n		    <a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/ladder"></a>\n        ';
 } 
__p+='\n	</div>\n</div>\n\n';
 if(status !== "scheduled" && !bye_rounds && is_round_bye) { 
__p+='\n	<div class="fixture-block">\n		NO FIXTURES IN ROUND '+
((__t=( current_round.id ))==null?'':_.escape(__t))+
' DUE TO BYE SETTINGS\n	</div>\n';
 } else if(num_teams == size && opponent ) { 
__p+='\n	<div class="fixture-block">\n		<div class="opponent-block left">\n			<picture>\n				<source srcset="'+
((__t=( home.avatar_url ))==null?'':_.escape(__t))+
'" type="image/webp">\n				<img src="/assets/images/test-avatar.png?v=1" alt="">\n			</picture>\n			<div class="opponent-name">'+
((__t=( home.team_name ))==null?'':_.escape(__t))+
'</div>\n		</div>\n\n		<div class="fixture-info">\n            <div class="opponents-points">\n				';
 if(home.score) { 
__p+='\n					<div class="points '+
((__t=( status ))==null?'':_.escape(__t))+
'  '+
((__t=( is_playing ? 'live' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( home.score))==null?'':_.escape(__t))+
'</div>\n				';
 }else if( home.proj_score ) { 
__p+='\n					<div class="proj-score">'+
((__t=( home.proj_score ))==null?'':_.escape(__t))+
'</div>\n				';
 }else { 
__p+='\n					<div class="points">-</div>\n				';
 } 
__p+='\n\n                <p>Vs</p>\n\n				';
 if(away.score) { 
__p+='\n					<div class="points '+
((__t=( is_playing ? 'live' : '' ))==null?'':_.escape(__t))+
'">'+
((__t=( away.score))==null?'':_.escape(__t))+
'</div>\n				';
 }else if( away.proj_score ) { 
__p+='\n					<div class="proj-score">'+
((__t=( away.proj_score ))==null?'':_.escape(__t))+
'</div>\n				';
 }else { 
__p+='\n					<div class="points '+
((__t=( is_playing ? 'live' : '' ))==null?'':_.escape(__t))+
'">-</div>\n				';
 } 
__p+='\n\n            </div>\n            ';
 if( status != 'scheduled' && current_round.id != 1 ){ 
__p+='\n                <a href="/fantasy/league/'+
((__t=( id ))==null?'':_.escape(__t))+
'/matchup/'+
((__t=( home.team_id ))==null?'':_.escape(__t))+
'/'+
((__t=( away.team_id ))==null?'':_.escape(__t))+
'/'+
((__t=( opponent.round ))==null?'':_.escape(__t))+
'" class="matchup-btn secondary-btn">Matchup</a>\n            ';
 } 
__p+='\n        </div>\n\n		<div class="opponent-block right">\n			<div class="opponent-name">'+
((__t=( away.team_name ))==null?'':_.escape(__t))+
'</div>\n			<picture>\n				<source srcset="'+
((__t=( away.avatar_url ))==null?'':_.escape(__t))+
'" type="image/webp">\n				<img src="/assets/images/test-avatar.png?v=1" alt="">\n			</picture>\n		</div>\n	</div>\n';
 } 
__p+='\n\n\n';
}
return __p;
};
